module.exports = __webpack_public_path__ + "img/checked.f3014c4a.svg";